<!-- 講座詳細レイアウト -->
<script setup lang="ts">
  const isTablet = isTabletAndSpDisplayRef();
</script>

<template>
  <!-- SP -->
  <div v-if="isTablet" class="d-flex flex-column">
    <slot name="thumbnail"></slot>
    <slot name="summary"></slot>
    <slot name="detail"></slot>
  </div>

  <!-- PC -->
  <div v-else class="d-flex flex-row justify-center">
    <!-- 左側 -->
    <div class="left-content mr-2">
      <slot name="thumbnail"></slot>
      <slot name="detail"></slot>
    </div>
    <!-- 右側 -->
    <div class="right-content">
      <div class="px-2">
        <slot name="summary"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .sticky-wrapper {
    height: 100vh;
    overflow-y: scroll;
    // スクロールバーを非表示にする (以下の一式でクロスブラウザ対応)
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .left-content {
    flex: 1;
    max-width: 960px;
  }

  .right-content {
    width: 384px;
    height: 100%;
    position: sticky;
    top: 0;
  }
</style>
